export default "__VITE_ASSET__Cp8qC_o1__"